(() => {
  const productHandle = (root) => {
    const link = root && root.querySelector('a[href*="/products/"]');
    if (!link) return "";
    const match = (link.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  };

  const addByHandle = async (handle, button) => {
    if (!handle) return;
    const label = button.textContent;
    button.disabled = true;
    button.textContent = "Adding...";
    try {
      const product = await fetch(`/products/${handle}.js`).then((r) => {
        if (!r.ok) throw new Error("product");
        return r.json();
      });
      const id = product.variants && product.variants[0] && product.variants[0].id;
      if (!id) throw new Error("variant");
      const cart = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, quantity: 1 }),
      });
      if (!cart.ok) throw new Error("cart");
      window.location.href = "/cart";
    } catch (err) {
      window.location.href = `/products/${handle}`;
    } finally {
      button.disabled = false;
      button.textContent = label;
    }
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".js-fs-add, [data-pf-type='ProductATC']");
    if (!button) return;
    event.preventDefault();
    const root = button.closest(".fs-direct__card, [data-pf-type='Column'], [data-pf-type='ProductBox'], .landing-replay") || document;
    addByHandle(productHandle(root) || productHandle(button.parentElement), button);
  });

  document.querySelectorAll(".landing-replay video[data-src]").forEach((video) => {
    if (!video.getAttribute("src")) video.src = video.getAttribute("data-src");
    video.muted = true;
    video.playsInline = true;
    video.play().catch(() => {});
  });

  const tickCountdown = (root) => {
    let data = {};
    try { data = JSON.parse(root.getAttribute("data-translation") || "{}"); } catch (err) { return; }
    const end = Date.parse(data.endTime || "");
    if (!end) return;
    const remain = Math.max(0, end - Date.now());
    const days = Math.floor(remain / 86400000);
    const hours = Math.floor((remain % 86400000) / 3600000);
    const mins = Math.floor((remain % 3600000) / 60000);
    const secs = Math.floor((remain % 60000) / 1000);
    const values = [days, hours, mins, secs];
    const labels = ["Days", "Hours", "Mins", "Secs"];
    const cells = root.querySelectorAll(".pf-countdown__inner > div");
    cells.forEach((cell, i) => {
      const number = cell.querySelector("[data-pf-type='CountdownNumber']");
      const label = cell.querySelector("[data-pf-type='CountdownLabel']");
      if (number) number.textContent = String(values[i]).padStart(2, "0");
      if (label) label.textContent = labels[i];
    });
    root.style.visibility = "visible";
  };

  document.querySelectorAll("[data-pf-type='CountDown']").forEach((node) => {
    tickCountdown(node);
    setInterval(() => tickCountdown(node), 1000);
  });
})();
